import _ from 'lodash'

const mixin = {
  methods: {
    rememberTab(tabKey) {
      if(this.$refs.tabs) {
        const prevTabName = sessionStorage.getItem(tabKey)
        const prevTab = _.find(this.$refs.tabs.$children, tab => tab.name === prevTabName)
        if(prevTab) {
          prevTab.isActive = true
        } else {
          this.$refs.tabs.$children[0].isActive = true
        }
        this.subscribe(`accordion-tab-changed`, tabName => {
          sessionStorage.setItem(tabKey, tabName)
        })
      }
    }
  }
}

export default mixin
